<template>
    <form @submit.prevent="armazenar">
        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <vc-pesquisa
                        @input="selecinouRemetente"
                        :extra="{fornecedor: 1, cliente: 1}"
                        label="Remetente"
                        nome-input="remetente_id"
                        :selecionado="form.remetente"
                        url-busca="api/pessoas/pesquisa"
                        :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                        :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]"
                        :obrigatorio="true">
                </vc-pesquisa>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Operação</label>
                    <v-select
                            v-model="form.operacao_select"
                            v-validate="{required: true}"
                            :options="[{value: 'CREDITO',label: 'Crédito'}, {value: 'DEBITO',label: 'Débito'}]"
                            data-vv-name="enviar boleto"
                    ></v-select>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Valor (R$)</label>
                    <money v-model="form.valor" class="form-control"></money>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-8">
                <div class="form-group">
                    <label>Descrição</label>
                    <textarea cols="60" rows="3" class="form-control" v-model="form.descricao"></textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group">
                    <button type="submit" class="btn btn-success">Salvar</button>&nbsp;
                    <router-link :to="{name: 'creditoDebito'}" class="btn btn-danger">Cancelar</router-link>
                </div>
            </div>
        </div>
    </form>

</template>

<script>
    import VcPesquisa from "@/components/Form/Pesquisa";

    export default {
        data() {
            return {
                form: {
                    valor: 0,
                    descricao: '',
                    operacao_select: {label: 'Crédito', value: 'CREDITO'},
                    operacao: 'CREDITO',
                    remetente_id: null
                },
            }
        },

        components: {
            VcPesquisa
        },

        watch: {
            "form.operacao_select"(select) {
                this.$set(this.form, 'operacao', select.value)
            },
        },

        computed: {
            editando() {
                return this.$route.name == 'creditoDebito.editar'
            },
        },

        methods: {
            selecinouRemetente(remetente) {
                this.$set(this.form, "remetente_id", remetente.id);
            },

            async armazenar() {
                if (this.form.remetente_id == null) {
                    return window.swal("Atenção!", "Informe um remetente antes de finalizar.", "warning");
                }

                if (this.form.valor <= 0) {
                    return window.swal("Atenção!", "Informe o valor antes de finalizar.", "warning");
                }

                if (this.form.descricao == '') {
                    return window.swal("Atenção!", "Informe a descrição antes de finalizar!", "warning");
                }

                if (this.editando) {
                    this.$http.put("api/creditoDebito/" + this.form.id, this.form).then(async () => {
                        window.swal("Sucesso!", (this.form.operacao == 'CREDITO' ? 'Crédito' : 'Débito') + ' gravado com sucesso.', "success").then(() => {
                            this.$router.push({name: "creditoDebito"});
                        });
                    })
                } else {
                    this.$http.post('api/creditoDebito', this.form).then(async () => {
                        window.swal("Sucesso!", (this.form.operacao == 'CREDITO' ? 'Crédito' : 'Débito') + ' gravado com sucesso.', "success").then(() => {
                            this.$router.push({name: "creditoDebito"});
                        });
                    })
                }
            },
        },

        async mounted() {
            if (this.editando) {
                this.$store.dispatch('setTitle', 'Editando crédito / débito')
                let credito = null
                await this.$http.get(`api/creditoDebito/${this.$route.params.id}`).then((response) => credito = response.data).catch(error => {
                    throw Error(error)
                })

                credito.operacao_select = credito.operacao == 'CREDITO' ? {label: 'Crédito', value: 'CREDITO'} : {value: 'DEBITO',label: 'Débito'}

                this.$set(this, 'form', credito)
            } else {
                this.$store.dispatch('setTitle', 'Adicionar crédito / débito')
            }
        }
    }
</script>
